import { useChatStore } from "@/stores/chat.store";
import { ChatPanel } from "./chat-panel";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export function ChatWidget() {
  const { isChatOpen, toggleChat, totalUnread } = useChatStore();

  return (
    <>
      {/* Floating chat button */}
      <Button
        onClick={toggleChat}
        className={cn(
          "fixed bottom-6 right-6 h-14 w-14 rounded-full shadow-lg z-40",
          "flex items-center justify-center",
          isChatOpen && "hidden",
        )}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
          />
        </svg>

        {/* Unread badge */}
        {totalUnread > 0 && (
          <span className="absolute -top-1 -right-1 inline-flex items-center justify-center h-6 min-w-[24px] px-1.5 text-xs font-bold text-white bg-red-500 rounded-full">
            {totalUnread > 99 ? "99+" : totalUnread}
          </span>
        )}
      </Button>

      {/* Chat panel (full screen overlay) */}
      <div
        className={cn(
          "fixed inset-0 bg-white z-50",
          "transform transition-transform duration-300 ease-in-out",
          isChatOpen ? "translate-x-0" : "translate-x-full",
        )}
      >
        {/* Header with close button */}
        <div className="absolute top-0 left-0 right-0 h-14 flex items-center justify-between px-4 border-b bg-white z-10">
          <h2 className="text-lg font-semibold">Messages</h2>
          <Button variant="ghost" size="icon" onClick={toggleChat}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </Button>
        </div>

        <ChatPanel className="h-full pt-14" />
      </div>

      {/* Backdrop */}
      {isChatOpen && (
        <div className="fixed inset-0 bg-black/30 z-40" onClick={toggleChat} />
      )}
    </>
  );
}
